export default __webpack_public_path__ + "static/tab4Img-46cbae8904a997a4c515f15a52150bbe.png";